(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('nasrac-admin', {
        	abstract: true,
            parent: 'app',
            data: {
                authorities: ['Administrators', 'DAC Content Administrator', 'DAC Content User']
            }
        });
    }
})();
